import '@babel/polyfill';
jQuery(function ($) {
    console.log('gens.jsが読みこまれたのだよ!!!');
    $('body').addClass('jquery-add-class');
});
if (document.querySelector('.banner-swiper')) {
    const bannerSwiper = new Swiper('.banner-swiper', {
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.banner-swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}">${index + 1}</span>`;
            }
        },
        speed: 1000
    });
}
if (document.querySelector('.item-swiper')) {
    const itemSwiper = new Swiper('.item-swiper', {
        loop: true,
        pagination: {
            el: '.item-swiper-pagination',
            clickable: true
        }
    });
}
let formCheckInputs = document.querySelectorAll(".p-estimate-form__check-item__input");
formCheckInputs.forEach(function (formCheckInput) {
    formCheckInput.addEventListener('change', function () {
        const parentElement = formCheckInput.parentNode.parentNode;
        if (this.checked) {
            parentElement.classList.add('checked');
        }
        else {
            parentElement.classList.remove('checked');
        }
    });
});
var fixedBlock = document.querySelector(".c-fixed-headline__btn");
var scrollableBlock = document.querySelector(".c-fixed-headline__contents");
var scrollableBlockTop = scrollableBlock.offsetTop;
var scrollableBlockBottom = scrollableBlockTop + scrollableBlock.offsetHeight;
var lastScrollTop = 0;
var clicked = false;
var scrollTimer = null;
window.addEventListener("scroll", function () {
    var windowScrollTop = window.scrollY || document.documentElement.scrollTop;
    var st = window.scrollY || document.documentElement.scrollTop;
    if (!clicked) {
        if (windowScrollTop >= scrollableBlockTop && windowScrollTop <= scrollableBlockBottom && st > lastScrollTop) {
            fixedBlock.classList.add("c-fixed-headline__btn--fixed");
            fixedBlock.classList.remove("c-fixed-headline__btn--fixedup");
        }
        else if (windowScrollTop >= scrollableBlockTop && windowScrollTop <= scrollableBlockBottom && st < lastScrollTop) {
            fixedBlock.classList.add("c-fixed-headline__btn--fixedup");
            fixedBlock.classList.remove("c-fixed-headline__btn--fixed");
        }
        else {
            fixedBlock.classList.remove("c-fixed-headline__btn--fixed");
            fixedBlock.classList.remove("c-fixed-headline__btn--fixedup");
        }
    }
    if (scrollTimer !== null) {
        clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(function () {
        clicked = false;
    }, 100);
    lastScrollTop = st <= 0 ? 0 : st;
});
window.addEventListener("resize", function () {
    scrollableBlockTop = scrollableBlock.offsetTop;
    scrollableBlockBottom = scrollableBlockTop + scrollableBlock.offsetHeight;
});
var links = document.querySelectorAll(".c-abc-link__list-inner");
for (var i = 0; i < links.length; i++) {
    links[i].addEventListener("click", function (event) {
        event.stopPropagation();
        clicked = true;
        fixedBlock.classList.add("c-fixed-headline__btn--fixedup");
    });
}
